import React, { useEffect } from 'react';
import { DemoProvider } from './contexts/DemoContext';
import { AppShell } from './components/shell/AppShell';
import { applyDocumentMeta } from './utils/documentMeta';
export function App() {
  useEffect(() => {
    applyDocumentMeta();
  }, []);
  return <DemoProvider data-id="element-0" data-mp="3fai02z30n7dp">
      <AppShell data-id="element-1" data-mp="3f9yhdg5jkeym" />
    </DemoProvider>;
}